import { useLocalObservable } from 'mobx-react-lite';

import { Call } from '@gem/call/CallStore/Call';
import { ICallPersonalizedPermissions } from '@gem/call/Model/callPermissions/callPermissionsModel.types';

import { ICallCustomPermissionsBlockProps } from './CallCustomPermissionsBlock.types';

interface ICallCustomPermissionsBlockPresenter {
  ongoingCall: Call;
  customPermissions: Map<string, ICallPersonalizedPermissions> | null;
  customPermissionsIds: string[] | null;
}

export const useCallCustomPermissionsBlockPresenter = (
  props: ICallCustomPermissionsBlockProps
): ICallCustomPermissionsBlockPresenter => {
  const presenter = useLocalObservable<ICallCustomPermissionsBlockPresenter>(() => ({
    get ongoingCall(): Call {
      return props.call;
    },

    get customPermissions(): Map<string, ICallPersonalizedPermissions> | null {
      return presenter.ongoingCall.permissions?.customPermissions || null;
    },

    get customPermissionsIds(): string[] | null {
      return presenter.ongoingCall.permissions.customPermissionsIds || null;
    },
  }));

  return presenter;
};
